import type { EndorsementOption, LocationProgram } from '@/api/types/enrollment'
import type { EligibilityFormData } from '../types'
import { shouldShowAdditionalInfoTrainingQuestions } from './helpers'

export function getAdditionalInfoSelectionState({
  endorsements,
  formData,
  programs,
  storedLocationExternalId,
  storedProgramExternalId
}: {
  endorsements: EndorsementOption[]
  formData: EligibilityFormData
  programs: LocationProgram[]
  storedLocationExternalId: string
  storedProgramExternalId: string
}) {
  const selectedLocationExternalId = formData.location || storedLocationExternalId || null
  const selectedProgramExternalId = formData.selectedProgram || storedProgramExternalId
  const selectedProgram = programs.find(
    program => program.productId === selectedProgramExternalId
  )
  const isInPersonAvailable = selectedProgram?.inPersonAvailable === true
  const isSelectedProgramYardOnly = selectedProgram?.yardOnly === true

  const shouldShowLaptopQuestion = shouldShowAdditionalInfoTrainingQuestions({
    formData,
    storedProgramExternalId,
    isSelectedProgramYardOnly
  })
  const isTrainingModeMissing = shouldShowLaptopQuestion && !formData.trainingMode
  const isLaptopSelectionMissing =
    shouldShowLaptopQuestion &&
    formData.trainingMode === 'remote' &&
    (formData.hasLaptop === null || formData.hasLaptop === undefined)

  const endorsementOptions = endorsements.filter(
    endorsement => Boolean(endorsement.type) && Boolean(endorsement.label)
  )

  return {
    endorsementOptions,
    isInPersonAvailable,
    isTrainingQuestionIncomplete: isTrainingModeMissing || isLaptopSelectionMissing,
    selectedLocationExternalId,
    shouldShowLaptopQuestion
  }
}

export function getNextEndorsements(currentEndorsements: string[], value: string) {
  if (currentEndorsements.includes(value)) {
    return currentEndorsements.filter(endorsement => endorsement !== value)
  }

  return [...currentEndorsements, value]
}

export function shouldResetUnavailableInPersonTraining({
  isInPersonAvailable,
  shouldShowLaptopQuestion,
  trainingMode
}: {
  isInPersonAvailable: boolean
  shouldShowLaptopQuestion: boolean
  trainingMode: EligibilityFormData['trainingMode']
}) {
  return shouldShowLaptopQuestion && !isInPersonAvailable && trainingMode === 'in-person'
}
